export enum TournamentStatusesEnum {
    WaitForApprove = 0,
    Approved = 1,
    Registration = 2,
    WaitForStartMatches = 3,
    GroupStage = 4,
    MainStage = 5,
    Cancelled = 6,
    Finished = 7
}